export default __webpack_public_path__ + "static/char-v-42-zh-Hant-ef19001e1577282b1fcb709c82493a4a.mp4";